import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  ConfirmBoxConfigModule,
  DialogConfigModule,
  NgxAwesomePopupModule,
  ToastNotificationConfigModule
} from '@costlydeveloper/ngx-awesome-popup';
import { DsAuthModule } from '@direction/auth';
import { DsCrudToolbarModule } from '@direction/crud-toolbar';
import { DsMessageModule } from '@direction/message';
import { DsSharedModule, ResourceService } from '@direction/translate';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgChartsModule } from 'ng2-charts';
import { ModalModule } from 'ngx-bootstrap/modal';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './core/components/auth/auth.component';
import { CoreModule } from './core/core.module';
import { SgaInterceptorService } from './core/services/sga-interceptor.service';
import { TurnstileService } from './core/services/turnstile.service';
import { ApplicationsComponent } from './home/applications/applications.component';
import { DashboardsComponent } from './home/dashboards/dashboards.component';
import { MainModule } from './main/main.module';
import { MiscellaneousModule } from './shared/miscellaneous/miscellaneous.module';

const maskConfig: Partial<IConfig> = {
  validation: false
};

const MaterialModules = [MatDatepickerModule, MatNativeDateModule];

@NgModule({
  declarations: [AppComponent, AuthComponent, ApplicationsComponent, DashboardsComponent],
  imports: [
    BrowserModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    CarouselModule,
    NgChartsModule,
    AppRoutingModule,
    HttpClientModule,
    DsMessageModule,
    BrowserAnimationsModule,
    DsSharedModule,
    CoreModule,
    MainModule,
    DsAuthModule,
    MaterialModules,
    NgxChartsModule,
    NgxSpinnerModule,
    MatProgressSpinnerModule,
    MiscellaneousModule,
    ModalModule.forRoot(),
    NgxMaskModule.forRoot(maskConfig),
    DsCrudToolbarModule.forRoot(environment.api),
    NgxAwesomePopupModule.forRoot(), // Essential, mandatory main module.
    DialogConfigModule.forRoot(), // Needed for instantiating dynamic components.
    ConfirmBoxConfigModule.forRoot(), // Needed for instantiating confirm boxes.
    ToastNotificationConfigModule.forRoot({
      globalSettings: {
        allowedNotificationsAtOnce: 1
      }
    })
  ],
  providers: [
    { provide: 'environment', useValue: environment },
    Title,
    {
      provide: LOCALE_ID,
      deps: [ResourceService],
      useFactory: (resourceService: ResourceService) => resourceService.getCurrencyCode()
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    //{ provide: ErrorHandler, useClass: ApplicationErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: SgaInterceptorService, multi: true },
    TurnstileService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
